<template>
  <div class="w-full py-20 lg:py-40 px-3 flex items-center justify-center triangle-bg">
    <loader v-if="cart.type === 'activities'" color="purple" />
    <div v-else class="booking-view relative border-4 border-purple bg-white rounded-lg px-3 lg:px-8 pb-10 pt-0 w-full max-w-2xl h-64 flex items-center justify-center">
      <loader color="purple" />
    </div>
  </div>
</template>

<script>
import Loader from '~/components/common/Loader'

export default {
  components: {
    Loader
  },
  async validate({ params, $api }) {
    return await $api.getPage(params.type, 'bookingFlow')
  },
  async asyncData({ params, store, $api }) {
    let flow = store.state.bookFlow
    if(!flow || flow.fields.slug != params.type) {
      flow = await $api.getPage(params.type, 'bookingFlow')
      store.commit('setFlow', flow)
    }
    return {
      flow: flow
    }
  },
  head() {
    return this.$metadata(this.flow, {
      link: [
        { rel: 'canonlical', href: `https://www.mainevent.com/book/${this.flow.fields.slug}/`}
      ]
    })
  },
  computed: {
    steps() {
      return this.flow.fields.steps
    },
    cart() {
      return this.$store.state.cart
    }
  },
  mounted() {
    // if(this.cart.type != this.$route.params.type) {
    //   console.log(this.cart.summary)
    //   this.resetCart()
    // }
    this.resetCart()
    setTimeout(this.redirect, 1000)
  },
  methods: {
    removeSummary(link = null) {
      if(this.cart.summary) {
        if(this.$store.state.account) {
          this.$mulesoftv3.deleteCustomerCart(this.$store.state.account.accountId, this.cart.location.centerId, this.cart.summary.id)
        } else {
          this.$mulesoftv3.deleteCart(this.cart.location.centerId, this.cart.summary.id)
        }
        this.$store.commit('cart/summary', null)
      }
      if(link) {
        this.$router.push(link)
      }
    },
    resetCart() {
      this.removeSummary()
      this.$store.commit('cart/type', this.$route.params.type)
    },
    redirect() {
      this.$router.push(`/book/${this.$route.params.type}/${this.steps[0].fields.slug}${typeof window != 'undefined' ? window.location.search : ''}`)
    }
  }
}
</script>